import logo from '@/assets/logo.png'
import homeIcon from '@/assets/nav/home-icon.png'
import groupIcon from '@/assets/nav/groups.png'
import folderIcon from '@/assets/nav/folder.png'
import taskIcon from '@/assets/nav/planner.png'
import settingIcon from '@/assets/nav/setting.png'
import { projectTypeItem } from '@/services/user/user.service'
import { ACCOUNT_TYPES, APP_NAME } from '@/utils/constants'
import { useRequest, useTitle } from 'ahooks'
import { Col, Layout, Menu, Row, Space, Spin, Typography } from 'antd'
import { Header } from 'antd/es/layout/layout'
import { createContext, memo, Suspense, useEffect, useMemo, useState } from 'react'
import { Link, Outlet, useParams } from 'react-router-dom'
import GlobalSearch from '../../components/GlobalSearch'
import Notification from '../../components/Notification'
import UserAction from '../../components/UserAction'
import styles from './index.module.less'
import { UserProjectAccess } from '@/services/member/member.model'
import { getActiveUnitSet } from '@/services/unitSet/unitSet.service'
import { ROLE_GENERAL } from '@/components/OPermission/PlanPermission'
import { useHasPermissions } from '@/components/OPermission/OPermission'
import { getUserProjectAccount } from '@/services/project/project'

const menuItems = [
  {
    key: 'workspace',
    label: <Link to={'./workspace'}>Workspace</Link>,
    icon: <MenuIcon icon={homeIcon} />,
    permissions: ROLE_GENERAL
  },
  {
    key: 'task',
    label: <Link to={'./tasks'}>Tasks</Link>,
    icon: <MenuIcon icon={taskIcon} />,
    permissions: ROLE_GENERAL
  },
  {
    key: 'members',
    label: <Link to={'./members'}>Members</Link>,
    icon: <MenuIcon icon={groupIcon} />
  },
  {
    key: 'files',
    label: <Link to={'./assets/files'}>Files</Link>,
    icon: <MenuIcon icon={folderIcon} />,
    permissions: ROLE_GENERAL,
    accountTypes: [ACCOUNT_TYPES.OWNER, ACCOUNT_TYPES.ADMINISTRATOR]
    // children: [
    //   {
    //     key: 'files',
    //     label: <Link to={'./assets/files'}>Files</Link>
    //   },
    //   // {
    //   //   key: 'book',
    //   //   label: <Link to={'./assets/book'}>Project Book</Link>
    //   // }
    // ]
  },
  {
    key: 'setting',
    label: <Link to={'./setting'}>Setting</Link>,
    icon: <MenuIcon icon={settingIcon} />,
    permissions: ['CHEMENG']
  }
]

export const projectContext = createContext({} as any)

export default memo(function MainLayout() {
  const { projectId } = useParams()
  const { data: projectData } = useRequest(() => projectTypeItem(projectId))
  const { data: unitSet} = useRequest(() => getActiveUnitSet({projectId}))
  const projectName = projectData ? `-${projectData.name}` : ''
  const [userAccess, setUserAccess] = useState<UserProjectAccess | null>(null)
  const {data: userProjectAccount} = useRequest(() => getUserProjectAccount(Number(projectId)))
  const hasPermission = useHasPermissions();
  useTitle(`${APP_NAME}${projectName}`)

  const authMenu = useMemo(() => {
    return menuItems.filter(item =>{
      if (item.accountTypes) {
        return item.accountTypes.includes((userProjectAccount?.accountType || '').toLowerCase())
      }
      return true
    }).filter(item => {
      if (item.permissions) {
        return hasPermission(item.permissions)
      }
      return true;
    })
  }, [hasPermission, userProjectAccount])

  if (!projectData) {
    return null
  }

  return (
    <Layout className='layout' style={{ height: '100%' }}>
      <Header className={styles.header}>
        <Row className={'w100'} align={'middle'} justify={'space-between'}>
          <Col flex={'auto'}>
            <Row gutter={16}>
              <Col style={{display: 'flex', alignItems: 'center'}}>
                <img height={32} src={logo} alt='logo' />
              </Col>
              <Col flex={'auto'}>
                <Menu mode='horizontal' className='main-menu' items={authMenu} style={{ width: '100%' }} />
              </Col>
            </Row>
          </Col>
          <Col>
            <Space align='center' size={16}>
              {/* <GlobalSearch /> */}
              {/* <ChatRoomWidget orgId={projectData.orgId} /> */}
              <Notification />
              <UserAction />
            </Space>
          </Col>
        </Row>
      </Header>

      <Layout.Content className={styles.content}>
        <div className={styles.contentChildren}>
          <projectContext.Provider
            value={{
              projectId,
              projectData,
              userAccess,
              unitSet
            }}
          >
            <Suspense fallback={<Spin size='large' tip='Loading...' />}>
              <Outlet />
            </Suspense>
          </projectContext.Provider>
        </div>
      </Layout.Content>
    </Layout>
  )
})

interface MenuIconProps {
  icon: any
}
function MenuIcon(props: MenuIconProps) {
  const {icon} = props;
  return <img height={30} src={icon} alt='logo' />
}